import { usePlaces } from '@/hooks/usePlaces';
import { PlaceCard } from '@/components/PlaceCard';

export function ExplorePage() {
  const { places } = usePlaces();
  const explore = places.filter((p) => ['attraction', 'recreation', 'beach'].includes(p.category) && p.locality === 'outside');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Explore</h1>
        <p className="page-subtitle">Outside town — caves, cliffs, day trips</p>
      </div>
      {explore.map((p) => (
        <PlaceCard key={p.id} place={p} />
      ))}
    </div>
  );
}
